import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsMessage from "graphql/fields/FieldsMessage";

const fields = {
	'guid': 'String!',
	'is_read': 'String',
	'active': 'String',
};

export default gql(`
	mutation message( ${ HelperGraphql.createFields( fields ) } ) {
	    message( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsMessage}
	        
	        attachment {
	            name
	            guid
	        }
	    }
	}
`);

